import { db } from '@/config/firebase';
import { doc, updateDoc } from 'firebase/firestore';

export const createPaymentIntent = async (amount: number, enrollmentId: string, email?: string) => {
  try {
    // Call the Firebase Function to create payment intent
    const response = await fetch('https://us-central1-way2driveschool.cloudfunctions.net/createPaymentIntent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount,
        enrollmentId,
        email,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to create payment intent');
    }

    // Update enrollment with payment intent ID
    await updateDoc(doc(db, "enrollments", enrollmentId), {
      paymentIntentId: data.paymentIntentId,
      paymentStatus: "pending",
    });

    return {
      success: true,
      clientSecret: data.clientSecret,
    };
  } catch (error) {
    console.error("Error creating payment intent:", error);
    return {
      success: false,
      error: "Failed to create payment intent",
    };
  }
};

export const handleWebhook = async (event: any) => {
  try {
    if (event.type === 'payment_intent.succeeded') {
      const paymentIntent = event.data.object;
      const enrollmentId = paymentIntent.metadata.enrollmentId;

      if (enrollmentId) {
        await updateDoc(doc(db, "enrollments", enrollmentId), {
          paymentStatus: "paid",
          status: "active",
          enrollmentStatus: "active",
        });
      }
    }
  } catch (error) {
    console.error("Error handling webhook:", error);
    throw error;
  }
}; 